export default __webpack_public_path__ + "static/media/network.5d618fdc.svg";